import request from "../utils/request";

///Category
export function getCategory(params) {
  return request({
    url: "/api/knowledge-base/categories",
    method: "get",
    params
  });
}
export function getOneCategory(params) {
  return request({
    url: `/api/knowledge-base/categories/${params.id}`,
    method: "get",
    params
  });
}
export function getSubCategoryClient(params) {
  return request({
    url: `api/knowledge-base/categories/${params.category}/subcategories?partial=1`,
    method: "get",
    params
  });
}
export function addCategory(data) {
  return request({
    url: "/api/knowledge-base/categories",
    method: "post",
    data
  });
}
export function putCategory(data) {
  return request({
    url: `/api/knowledge-base/categories/${data.get("id")}`,
    method: "put",
    data
  });
}
export function deleteCategory(data) {
  return request({
    url: `/api/knowledge-base/categories/${data.id}`,
    method: "delete",
    data
  });
}
///SubCategory
export function getSubCategory(params) {
  return request({
    url: `/api/knowledge-base/categories/${params.id}/subcategories`,
    method: "get",
    params
  });
}
export function getOneSubCategory(params) {
  return request({
    url: `/api/knowledge-base/subcategories/${params.id}`,
    method: "get",
    params
  });
}
export function addSubCategory(data) {
  return request({
    url: "/api/knowledge-base/subcategories",
    method: "post",
    data
  });
}
export function putSubCategory(data) {
  return request({
    url: `/api/knowledge-base/subcategories/${data.id}`,
    method: "put",
    data
  });
}
export function deleteSubCategory(data) {
  return request({
    url: `/api/knowledge-base/subcategories/${data.id}`,
    method: "delete",
    data
  });
}

///Post

export function getAllPosts(params) {
  return request({
    url: `/api/knowledge-base/posts`,
    method: "get",
    params
  });
}
export function getPost(params) {
  return request({
    url: `/api/knowledge-base/subcategories/${params.id}/posts`,
    method: "get",
    params
  });
}
export function getOnePost(params) {
  return request({
    url: `/api/knowledge-base/posts/${params.id}`,
    method: "get",
    params
  });
}
export function getFilesByPost(params) {
  return request({
    url: `/api/knowledge-base/post-files`,
    method: "get",
    params
  });
}
export function addFilesToPost(data) {
  return request({
    url: `/api/knowledge-base/post-files`,
    method: "post",
    data
  });
}
export function deleteFilesFromPost(data) {
  return request({
    url: `/api/knowledge-base/post-files`,
    method: "delete",
    data
  });
}
export function addPost(data) {
  return request({
    url: "/api/knowledge-base/posts",
    method: "post",
    data
  });
}
export function putPost(data) {
  return request({
    url: `/api/knowledge-base/posts/${data.id}`,
    method: "put",
    data
  });
}
export function deletePost(data) {
  return request({
    url: `/api/knowledge-base/posts/${data.id}`,
    method: "delete",
    data
  });
}
